/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { bool, func, object } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import MarkdownText from './Partials/MarkdownText';
import InputField from './Partials/InputField';
import noop from '../../../../../helpers/noop';
import { setOfferInboxOffers } from '../../../../../../state/ducks/App/App-Actions';
import { getOfferInboxOfferPayloadById } from '../../../../../../state/ducks/App/App-Selectors';
import OfferButton from './Partials/OfferButton';

const useStyles = makeStyles((theme) => ({
    container: {
        border: '1px solid transparent',
        borderImage: 'repeating-linear-gradient(45deg, #D9D9D9 0 5px, transparent 5px 10px) 1',
        borderImageSlice: 1,
        borderRadius: '6px',
        padding: '18px',
    },
    text: {
        margin: '8px 0',
    },
    marginTop: {
        marginTop: '28px',
    },
    inlineBlock: {
        display: 'inline-block',
    },
}));

const WithImageDesign = ({ offer, notFirst, trackClickThrough }) => {
    const isOfferGateway = offer?.type === 'offer-gateway';
    const structure = (isOfferGateway ? offer?.content?.structure : offer?.structure) || [];
    const campaignPayload = offer?.campaign?.campaignResponses?.[0]?.payload || {};
    const offerUID = isOfferGateway ? offer?.content?.uid : offer?.uid;
    const offerData = useSelector((state) => getOfferInboxOfferPayloadById(state, offerUID));
    const classes = useStyles();
    const dispatch = useDispatch();

    const inputFormId = offer?.content?.input_form_id;

    useEffect(() => {
        const stateMap = {};
        if (!offerData?.buttonState) {
            structure?.forEach((item) => {
                if (item?.button) {
                    const { button_id, button_state } = item.button;
                    // Only add if button_id is not null/undefined and not already added
                    if (button_id !== null && !(button_id in stateMap)) {
                        stateMap[button_id] = button_state;
                    }
                }
            });

            const offerPayload = {
                offerId: offerUID,
                offer: {
                    buttonState: stateMap,
                },
            };

            dispatch(setOfferInboxOffers(offerPayload));
        }
    }, []);

    const renderStructureItem = (item, index) => {
        const keys = Object.keys(item);
        const data = item[keys[0]];

        switch (keys[0]) {
            case 'text':
                return <MarkdownText key={index} data={data} />;

            case 'image':
                return (
                    <img
                        key={index}
                        src={data?.file?.url}
                        alt={item.alt || 'Offer Image'}
                        style={{ maxWidth: '100%' }}
                    />
                );

            case 'input_field':
                return (
                    <InputField
                        key={index}
                        data={data}
                        className={classes.text}
                        offer={offer}
                        formId={inputFormId}
                    />
                );

            case 'button':
                return (
                    <OfferButton
                        key={index}
                        buttonData={data}
                        offer={offer}
                        className={`${data?.cta_button?.full_width ? '' : classes.inlineBlock}`}
                        trackClickThrough={trackClickThrough}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            <div className={`${classes.container} ${notFirst ? classes.marginTop : ''}`}>
                {
                    structure.map((item, index) => (renderStructureItem(item, index)))
                }
            </div>
        </>
    );
};

WithImageDesign.propTypes = {
    offer: object,
    notFirst: bool,
    trackClickThrough: func,
};

WithImageDesign.defaultProps = {
    offer: {},
    notFirst: false,
    trackClickThrough: noop,
};

export default WithImageDesign;
